import React from "react";
import { authenticationService } from "../../services/context/AuthService";
import { AlertModal, Button, IconLogOut } from "@veneer/core";
import { history } from "../../services/helpers/history";
import { useTranslation } from "react-i18next";
import i18n from '../../i18n';

const SessionExpiredModal = () => {
  const { t } = useTranslation();
  i18n.changeLanguage(localStorage.getItem('language'));

  const handleClick = () => {
    authenticationService.logout();
  };

  return (
    <AlertModal
      show={true}
      title={t('sessionExpired')}
      footer={
        <Button onClick={handleClick} leadingIcon={<IconLogOut />}>
          {t('goToLoginPage')}
        </Button>
      }
    >
      <p>{t('loginRequestMessage')}</p>
    </AlertModal>
  );
};

export default SessionExpiredModal;
